import { useEffect, useState } from 'react';
import { hasRegExpMatchingGroups } from 'utils/regexp/hasRegExpMatchingGroups';
import { isValidRegExp } from 'utils/validation/isValidRegExp';

export const useRegExpHasMatchingGroup = (ruleRegex: string): boolean => {
  const [hasGroup, setHasGroup] = useState(() =>
    hasRegExpMatchingGroups(ruleRegex),
  );

  useEffect(() => {
    // Preserve the last valid value while the user is typing an invalid regex.
    if (isValidRegExp(ruleRegex)) {
      setHasGroup(hasRegExpMatchingGroups(ruleRegex));
    }
  }, [ruleRegex]);

  return hasGroup;
};
